(function ($) {

    'use strict';
    const CONTENT_MAX_HEIGHT = 18 * 4;

    class MktDescription extends HTMLElement {
        constructor() {
            super();
            this.width = this.getAttribute('width') || '100%';
            this.viewMoreText = this.getAttribute('view-more-text') || 'View More';
            this.viewLessText = this.getAttribute('view-less-text') || 'View Less';
            const template = document.createElement('template');
            template.innerHTML = `
                <style>
                    .accordion {
                        padding: 24px;
                        background: #f8f9fd !important;
                        border-radius: 8px;
                        width: ${this.width};
                        box-sizing: border-box;
                    }
                    .accordion-button {
                        display: none;
                        cursor: pointer;
                        user-select: none;
                        margin-top: 16px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #0074ff;
                    }
                    
                    .accordion-content {
                        position: relative;
                        overflow: hidden;
                        transition: height 0.3s ease;
                        max-height: ${CONTENT_MAX_HEIGHT}px;
                    }
                    .accordion-content.show-button:after {
                        position: absolute;
                        content: "";
                        width: 100%;
                        left: 0;
                        bottom: -4px;
                        height: 32px;
                        background: linear-gradient(360deg, #f8f9fd 0%, rgba(248, 248, 248, 0.00) 100%);
                    }
                    .accordion-content.active {
                        height: auto !important;
                        max-height: fit-content;
                    }
                    .accordion-content.active::after{
                        display: none;
                    }
                    
                    ::slotted([slot="content"]){
                        display: block;
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    ::slotted(.content) {
                      display: block !important;
                    }
           
                </style>
                <div part="description-accordion" class="accordion" style="background: #f8f9fd !important;" >
                    <div class="accordion-content">
                        <slot name="content"></slot>
                    </div>
                    <div class="accordion-button">
                        <div class="container btn-default" data-sensors-click style="display: flex; justify-content: left; align-items: center;">
                            <span>${this.viewMoreText}</span>
                            <svg class="learnmore-arrow" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                p-id="5772" width="20" height="20">
                                <path
                                    d="M225.408 368.384L496 640.641l270.592-272.257-48.64-49.024L496 542.592 274.176 319.36l-48.768 49.024z m0 0z"
                                    fill="#0074ff" p-id="5773"></path>
                            </svg>
                        </div>
                        <div class="container btn-active" data-sensors-click style="display: none; justify-content: left; align-items: center;">
                            <span>${this.viewLessText}</span>
                            <svg style="transform: rotate(180deg);" class="learnmore-arrow" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="5772" width="20" height="20">
                                <path
                                    d="M225.408 368.384L496 640.641l270.592-272.257-48.64-49.024L496 542.592 274.176 319.36l-48.768 49.024z m0 0z"
                                    fill="#0074ff" p-id="5773"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            `;
            if (!this.shadowRoot) {
                this.attachShadow({ mode: 'open' });
            }
            // 创建 shadow DOM，并将模板内容添加到其中
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            // 获取 button 和 content 元素
            this.button = this.shadowRoot.querySelector('.accordion-button');
            this.content = this.shadowRoot.querySelector('.accordion-content');

            // 添加事件监听器
            this.button.addEventListener('click', () => {
                this.toggle();
            });
        }
        connectedCallback() {
            let contentHeight = this.content.scrollHeight;
            if (contentHeight > CONTENT_MAX_HEIGHT) {
                this.button.style.display = 'block';
                this.content.classList.add('show-button')
            }
        }

        toggle() {
            this.button.classList.toggle('active');
            this.content.classList.toggle('active');
            // 计算 content 的高度
            let contentHeight = this.content.scrollHeight;
            const afterEl = window.getComputedStyle(this.content, ':after');
            const afterHeight = parseInt(afterEl.height);
            contentHeight -= afterHeight;
            // 设置 content 的高度，以实现动画效果
            if (this.content.classList.contains('active')) {
                this.button.querySelector('.btn-active').style.display = 'flex';
                this.button.querySelector('.btn-default').style.display = 'none';
            } else {
                this.content.style.height = CONTENT_MAX_HEIGHT;
                this.button.querySelector('.btn-active').style.display = 'none';
                this.button.querySelector('.btn-default').style.display = 'flex';
            }
        }

    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('mkt-description', MktDescription);
    });
})(jQueryTheme);